<template>
	<div>
		<v-alert type="error" v-show="showAlert">
			{{ txt.error }}
		</v-alert>
		<v-progress-circular
			indeterminate
			color="primary"
			v-show="loading"
		/>
		<order-import-filter
			:loading="loading"
			@previewOrders="previewOrders"
			@loadOrders="loadOrders"
		/>
		<span style="white-space: pre-line">
			{{ txt.reimportState }}
		</span>
		List of created files: {{ fileList }}
		<span style="white-space: pre; overflow: auto; display:block;">{{ this.openedFileContents }}</span>
	</div>
</template>

<script>
import OrderImportFilter from './OrderImportFilter.vue'
import axios from 'axios'

export default {
	components: { OrderImportFilter },
	name: 'OrderImportTool',
	data() {
		return {
			loading: false,
			txt: {
				error: '',
				reimportState: '',
			},
			showAlert: false,
			fileList: [],
			openedFileContents: '',
		}
	},
	methods: {
		async previewOrders(params) {
			try {
				this.showAlert = false
				this.loading = true
				this.txt.reimportState = ''
				// trigger Airflow JOB
				await axios.post(`${config.baseAPIurl}/order-import/preview-orders`, {
					params,
				})
				this.txt.reimportState += `Job successfully triggered. Please wait for execution...
				1. Executing SQL Query on PEAK Customer Environment...
				2. Writing SQL Query Data to S3...`

				// wait for the job to be finished
				const finalState = (await axios.get(`${config.baseAPIurl}/order-import/job-state`, {
					params: {
						jobName: 'extract_missing_revenue_orders',
					},
				})).data.state
				if (finalState === 'success') {
					this.txt.reimportState += 'Successfully written to S3. If the data in table below looks OK, please click on Load Orders.'
				} else {
					this.txt.reimportState += 'Failed to execute a query and write the data to S3. Please contact ARC team for assistance'
					return
				}

				// get the list of files created in S3
				const today = new Date().toISOString().substring(0, 10)
				const files = await axios.get(`${config.baseAPIurl}/admin-page/S3/get-files`, {
					params: {
						installationId: params.selectedMandators.value,
						dateOfExport: today,
						reimportTool: '1',
					},
				})
				this.fileList = files.data.Contents.map((el) => el.Key)

				// read the files
				let promisesForFileReads = []
				for (const file of this.fileList) {
					promisesForFileReads.push(axios.get(`${config.baseAPIurl}/admin-page/S3/read-file`, {
						params: {
							fileKey: file,
						},
					}))
				}
				promisesForFileReads = await Promise.all(promisesForFileReads)
				for (const file of promisesForFileReads) {
					this.openedFileContents += file.data
				}
			} catch (error) {
				this.txt.error = error
				this.showAlert = true
			} finally {
				this.loading = false
			}
		},
		async loadOrders(params) {
			try {
				this.showAlert = false
				this.loading = true
				this.txt.reimportState = ''
				// trigger Airflow JOB
				await axios.post(`${config.baseAPIurl}/order-import/load-orders`, {
					params,
				})
				this.txt.reimportState += `Job successfully triggered. Please wait for execution...
				1. Reading S3 files...
				2. Loading files into ARC Stage and Live...
				`

				// wait for the job to be finished
				const finalState = (await axios.get(`${config.baseAPIurl}/order-import/job-state`, {
					params: {
						jobName: 'load_missing_revenue_orders',
					},
				})).data.state
				if (finalState === 'success') {
					this.txt.reimportState += 'Successfully read from S3. If the data in table below looks OK, please click on Load Orders.'
				} else {
					this.txt.reimportState += 'Failed to read S3 file. Please contact ARC team for assistance'
					return
				}

				this.txt.reimportState += `Successfully loaded data.
				You can check if the data is loaded correctly by opening Revenue Report for the selected mandator, 
				looking at the dates in the entries below, making an accounting excel export and checking if the entered
				increment IDs are now visible in the second sheet of the export.
				`
			} catch (error) {
				this.txt.error = error
				this.showAlert = true
			} finally {
				this.loading = false
			}
		},
	},
}
</script>

<style>

</style>
